/**
 * The number of additional lines to include before and after the highlighted code block.
 * This padding provides context around the specific lines of interest.
 * @constant {number}
 * @default 3
 */
export const linesPadding = 3;

export const selectedInlineNumberMark = 'selected-inline-number-mark';
export const unselectedInlineNumberMark = 'unselected-inline-number-mark';

export const inlineSectionMarker = 'inline-section-marker';
export const selectedInlineSectionMarker = 'selected-inline-section-marker';

export const inlineItemMark = 'inline-item-mark';
export const selectedInlineItemMark = 'selected-inline-item-mark';

export const numMarkerIdPrefix = 'NUM-MARKER-';
export const textMarkerIdPrefix = 'TEXT-MARKER-';
export const textSpanMarkerIdPrefix = 'TEXT-SPAN-MARKER-';
